import { api } from '../../DefaultService';
import { IIvsEventProps, IIvsEventSimpleProps } from './types';
import { IPaginationParams } from '../../types';

export const IVS_EVENT_ENDPOINT = 'v1/events/ivs';

export const getIvsEventByIdAsync = async (
  id: number,
): Promise<IIvsEventProps> => {
  return await api
    .get(`${IVS_EVENT_ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllIvsEventByLicenseAsync = async (
  params: IPaginationParams,
): Promise<IIvsEventSimpleProps[]> => {
  return await api
    .get(`${IVS_EVENT_ENDPOINT}/getAllByLicense`, {
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllIvsEventCountByLicenseAsync = async (): Promise<number> => {
  return await api
    .get(`${IVS_EVENT_ENDPOINT}/getAllByLicense/count`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
